import { useQuery } from '@tanstack/react-query'
import {
	type GetCsvUploadsParams,
	httpGetCsvUploads
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const CSV_UPLOADS_QUERY_KEY = 'csv-uploads'

export const useGetCsvUploads = (params: GetCsvUploadsParams = {}) =>
	useQuery({
		queryKey: [CSV_UPLOADS_QUERY_KEY, params],
		queryFn: () => httpGetCsvUploads(params)
	})
